import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import apiService from '../services/apiservices'
import { clusterTableReady} from '../redux/clusters'


//import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/clusterTable.css'


import { MoveKitchenCluster } from './ActionButtons'

import * as Helpers from '../../../common/helpers'

//import TimePicker from 'react-time-picker'

class KitchensCollapsibleRow extends Component {
    constructor() {
        super()
        this.state = {
            updatedTimingArr:[],
            clearIcon:null
        }
        this.dialog = null
    }

    componentWillMount() {
    }


    removeCusterKitchen = (row) =>{
        
        if (window.confirm("Are you sure?") === true) {
            this.props.dispatch(clusterTableReady(false))
             apiService.removeCusterKitchen(row.kitchen_id)
            .then(responseData => {                 
                    if (responseData.status === "SUCCESS") {
                        this.props.dispatch(clusterTableReady(true))
                        window.location.reload();                        
                    } else {

                        this.props.dispatch(clusterTableReady(true))
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                
            })
            .catch(err => {
                this.props.dispatch(clusterTableReady(true))
                console.error("Error data: ", err)
               alert("exception"+ err);
            })
        
        } 
    }

    
     actionCreator = (cell, row, enumObject, rowIndex) => {
        //debugger;
        
        let moveKitchen=""
        
        if(Helpers.checkPrivileges("/dashboard/clusters/addEdit",this.props.user)){

            moveKitchen=<MoveKitchenCluster data={row}/>
         
         }
         
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{moveKitchen} </div>
        </div>)
    }

    

    render() {
        const options = {
            page: 1,  // which page you want to show as default
            sizePerPage: 10,  // which size per page you want to locate as default
        }
        return (
            <div style={{ backgroundColor: "#e1e5ed",margin: "0% 4%" }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    className="table-border"
                    options={options}
                    data={this.props.row.kitchens}
                    hover={false}
                    headerStyle={{ border: '0px', color: '#000' }}
                    tableStyle={{ border: '0px' }}
                    bodyStyle={{ border: '0px', overflow: "auto" }}>

                     {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="kitchen_id"
                                            width="80"
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{background:"white"}}
                                            thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="kitchen_id"
                                            width="1"
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            tdStyle={{background:"white"}}
                                            thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}

                    <TableHeaderColumn
                        dataField="kitchen_code"
                        className="table-header"
                        columnClassName="table-body"
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Code
                    </TableHeaderColumn> 

                    <TableHeaderColumn
                        dataField="kitchen_name"
                        className="table-header"
                        columnClassName="table-body"
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Kitchen
                    </TableHeaderColumn>  


                    <TableHeaderColumn
                        dataField="kitchen_manager_name"
                        className="table-header"
                        columnClassName="table-body"
                        dataAlign='left'
                        tdStyle={{background:"white"}}
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Kitchen Manager
                    </TableHeaderColumn>  

                  
                    
                    <TableHeaderColumn
                        className="table-header"
                        dataFormat={this.actionCreator}
                        dataAlign='center'
                        thStyle={{ whiteSpace: 'normal',color:'white',background :"#f0b209", textAlign:'left'}}>
                        Actions
                    </TableHeaderColumn>                  
                
                </BootstrapTable>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        stores: state.stores,
        user: state.user
    }
}

export default connect(mapStateToProps)(withRouter(KitchensCollapsibleRow))


// WEBPACK FOOTER //
// ./src/modules/Clusters/Components/KitchensCollapsibleRow.js